import React, { useEffect, useState } from 'react'
import { lower } from 'change-case'
import { FieldArray, Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { Button, Icon } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { validations, validateCase as vCase } from 'core/validate'
import { CommitteeContainer } from './styled'
import r from 'reactotron-react-js'

const Committee = (props) => {
  const { valueForm, isDisplay = false, members, showCollapse = true } = props
  const [showCommitteeInfo, setShowCommitteeInfo] = useState(true)

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const memberOptions = (index) => {
    var listCommittees = []
    var committeesValue = valueForm.committees || []
    
    committeesValue.forEach((c, i) => {
      if (index > i) {
        listCommittees.push(c.username)
      }
    })
    
    var result = []
    members.data.forEach(m => {
      if (!listCommittees.includes(m.username)) {
        result.push({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` })
      }
    })

    return result
  } 

  const renderCommittees = ({ fields, meta: { error } }) => {
    return (
      <React.Fragment>
        {
          fields.map((committee, index) => {
            return (
              <div className='rowFields' style={{ marginBottom: '10px' }} key={`committee_${index}`}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }} >{index + 1}. </div>
                <Field 
                  name={`${committee}.username`}
                  label=''
                  editable={editableForm()}
                  type={type.select}
                  options={memberOptions(index)}
                  style={{ marginBottom: '0px' }}
                  component={FieldInput}
                />
                {
                  editableForm() ?
                    <Button icon color='red' onClick={() => fields.remove(index)}>
                      <Icon name='trash' />
                    </Button> : null
                }
              </div>
            )
          })
        }
        {
          editableForm() ?
            <div className='rowFields'>
              <Button 
                color='primary' 
                disabled={(valueForm.committees || []).length >= 10}
                onClick={() => fields.push({ username: '' })}
              >
                Add
              </Button>
            </div> : null
        }
      </React.Fragment>
    )
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Committee'
        action={
          showCollapse ? 
            <IconButton aria-label='Expand' onClick={() => setShowCommitteeInfo(!showCommitteeInfo) }>
              {showCommitteeInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton> : null
        }
      />
      <Collapse in={showCommitteeInfo}>
        <CardContent>
          <CommitteeContainer>
            <Field name='committeeErrorMessage' type={type.labelOnly} component={FieldInput} />
            <FieldArray 
              name='committees'
              component={renderCommittees}
            />
          </CommitteeContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

export default Committee